/* ShirTCG sticky ATC (2026-07-28, r5). Mobile-only fixed bottom Add-to-cart bar that
   appears once the real ATC scrolls off the top of the viewport. Submits the REAL
   product form (button[form=] attribute) so variant/cart logic stays Dawn-native.
   Mirrors the main button's label/disabled state and exact CTA colors.
   r2: form.getAttribute('id') (form.id resolves to <input name="id"> via named-property
   shadowing); live-rect visibility (IO entry rects are crossing-moment snapshots).
   r3: form selected INSIDE <product-form> ('product-form-' prefix also matches the
   non-intercepted installment form -> full-page POST).
   r4: self-healing button reference (app embeds re-render the buy area, detaching nodes).
   r5: scroll handler runs update() directly — no rAF deferral (rAF + IO starve in
   background/hidden tabs, which also made the feature untestable headlessly; a single
   rect read + class toggle per scroll event is cheap).
   r6: bar background SAMPLED from nearest opaque ancestor of the real ATC (David's
   flag: rgb(var(--color-background)) resolves against body's scheme-1 = WHITE, while
   visible sections run a dark scheme — Dawn scopes scheme vars per section). Solid
   dark fallback when only a gradient image is found. */
(() => {
  const init = () => {
    const info = document.querySelector('product-info');
    const form = info && info.querySelector('product-form form[id^="product-form-"]');
    let mainBtn = info && info.querySelector('button[name="add"]');
    if (!info || !form || !mainBtn) return;
    if (document.querySelector('.stcg-sticky-atc')) return;

    const style = document.createElement('style');
    style.textContent = [
      '.stcg-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:4;',
      'padding:.8rem 1.2rem calc(.8rem + env(safe-area-inset-bottom,0px));',
      'background:#121212;box-shadow:0 -2px 12px rgba(0,0,0,.18);',
      'transform:translateY(110%);transition:transform .25s ease;}',
      '.stcg-sticky-atc.is-visible{transform:translateY(0);}',
      '@media screen and (min-width:750px){.stcg-sticky-atc{display:none;}}',
      '.stcg-sticky-atc__btn{width:100%;min-height:4.8rem;font-size:1.6rem;',
      'letter-spacing:.04em;border:none;border-radius:4px;cursor:pointer;font-weight:600;}',
      '.stcg-sticky-atc__btn[disabled]{opacity:.55;}'
    ].join('');
    document.head.appendChild(style);

    const bar = document.createElement('div');
    bar.className = 'stcg-sticky-atc';
    const btn = document.createElement('button');
    btn.type = 'submit';
    btn.setAttribute('form', form.getAttribute('id'));
    btn.className = 'stcg-sticky-atc__btn';
    bar.appendChild(btn);
    document.body.appendChild(bar);

    const paint = () => {
      const cs = getComputedStyle(mainBtn);
      btn.style.backgroundColor = cs.backgroundColor;
      btn.style.color = cs.color;
      let el = mainBtn.parentElement, bg = '', bgImg = '';
      while (el && el !== document.documentElement) {
        const s = getComputedStyle(el);
        const hasImg = s.backgroundImage && s.backgroundImage !== 'none';
        const hasColor = s.backgroundColor && s.backgroundColor !== 'transparent' && !s.backgroundColor.startsWith('rgba(0, 0, 0, 0');
        if (hasImg || hasColor) { if (hasImg) bgImg = s.backgroundImage; if (hasColor) bg = s.backgroundColor; break; }
        el = el.parentElement;
      }
      bar.style.backgroundColor = bg || '#121212';
      bar.style.backgroundImage = bgImg || 'none';
    };
    const sync = () => {
      btn.disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      const label = (mainBtn.textContent || '').replace(/\s+/g, ' ').trim();
      if (label && btn.textContent !== label) btn.textContent = label;
    };
    const mo = new MutationObserver(sync);
    const watch = () => {
      mo.disconnect();
      mo.observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
      paint();
      sync();
    };
    const resolveBtn = () => {
      if (mainBtn && mainBtn.isConnected) return true;
      const fresh = document.querySelector('product-info button[name="add"]');
      if (!fresh) return false;
      mainBtn = fresh;
      watch();
      return true;
    };
    const update = () => {
      if (!resolveBtn()) { bar.classList.remove('is-visible'); return; }
      bar.classList.toggle('is-visible', mainBtn.getBoundingClientRect().bottom < 0);
    };
    watch();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

